module.exports = __webpack_public_path__ + "img/planmate.04e86453.jpg";